module.exports = new Backbone.Model({
    isPrimeUser: undefined,
    hasPrimeDiscount: false,
});
